<template>
    <div v-if="hasJobs" class="mr-3 uncomp-jobs">
        <v-tooltip text="New Nu-Wall" location="bottom">
            <template v-slot:activator="{ props }">
                <v-badge @click="showJobs" :content="jobs.length">
                    <v-icon icon="mdi-new-box" v-bind="props" class="text-yellow-lighten-3"></v-icon>
                </v-badge>
            </template>
        </v-tooltip>
        <v-dialog v-model="jobModal"
                  persistent
                  :scrim="false">
            <v-card>
                <v-toolbar dark
                           color="primary">
                    <v-spacer></v-spacer>
                    <v-btn icon
                           dark
                           @click="jobModal = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <p>Below is a list of new Nu-Wall. Please click accepted.</p>
                    <v-table>
                        <thead>
                            <tr>
                                <th class="text-left">Job</th>
                                <th class="text-left">Customer</th>
                                <th class="text-left">Customer Number</th>
                                <th class="text-left">$</th>
                                <th class="text-right"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="job in jobs" :key="job.id">
                                <td> <router-link :to="'/'+$constants.entities.Job.ROUTE+job.id" @click="jobModal=false">{{ job.name }}</router-link></td>
                                <td>{{ job.customerName }}</td>
                                <td>{{ job.customerNumber }}</td>
                                <td>{{ numberWithCommas(job.jobSubTotal, 2) }}</td>
                                <td><v-btn :loading="job.accepting" color="primary" @click="acceptJob(job)">ACCEPT</v-btn></td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
    .uncomp-jobs {
        cursor: pointer;
    }
</style>
<script>
    import { numberWithCommas } from "../mixins/numberMixins";
    import { mapActions } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false,
            jobs: null,
            jobModal: false,
            refreshInterval: null
        };
    }
    export default {
        name: "NewWall",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadData();
            this.refreshInterval = setInterval(() => {
                this.loadData();
            }, 600000);
        },
        beforeUnmount: function () {
            // Clean up the interval when component is destroyed
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
            }
        },
        props: {
            props: Object,
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            numberWithCommas,
            showJobs() {
                this.jobModal = true;
            },
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            loadData() {
                this.loading = true;
                this.$api.get('dashboard/statusjobs?status=0')
                    .then(res => {
                        this.jobs = res.data;
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorSnack("Whoops. We ran into an error.");
                    });
            },
            acceptJob(job) {
                this.$confirm(
                    {
                        message: 'Are you sure you want to accept this job?',
                        disableKeys: false,
                        auth: false,
                        button: {
                            no: 'No',
                            yes: 'Yes'
                        },
                        callback: confirm => {
                            if (confirm) {
                                job.accepting = true;
                                this.$api.post('jobs/acceptdraft?id=' + job.id)
                                    .then(res => {
                                        job.accepting = false;
                                        // Remove from list
                                        this.jobs = this.jobs.filter(j => j.id !== job.id);
                                    }).catch(error => {
                                        job.accepting = false;
                                        this.showErrorSnack("Whoops. We ran into an error.");
                                    });
                            }
                        }
                    }
                )
            }
        },
        computed: {
            hasJobs() {
                return this.jobs && this.jobs.length > 0;
            }
        }
    };
</script>